import { LogIn } from "lucide-react";
import { signInWithGoogle } from "../lib/auth";
import { profile } from "../data/content";

// Public sign-in page — shown until the visitor authenticates with Google.
export default function SignIn() {
  return (
    <div className="min-h-screen bg-canvas text-ink font-sans antialiased flex flex-col" data-testid="signin-page">
      <header className="border-b border-hairline">
        <div className="container-x h-16 flex items-center">
          <span className="w-9 h-9 border border-cardline bg-panel flex items-center justify-center font-display text-sm font-semibold">
            {profile.initials}
          </span>
        </div>
      </header>

      <main className="flex-1 flex items-center">
        <div className="container-x py-20">
          <div className="max-w-md">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-teal">Private portfolio</p>
            <h1 className="mt-5 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-ink">
              Sign in to view this portfolio.
            </h1>
            <p className="mt-4 text-base text-body leading-relaxed">
              It includes confidential company work, so I ask visitors to sign in with Google first. It takes a few
              seconds — no password needed.
            </p>
            <button
              data-testid="google-signin-button"
              onClick={signInWithGoogle}
              className="mt-8 inline-flex items-center gap-2 bg-teal text-canvas text-sm font-medium px-6 py-3 hover:bg-teal-deep transition-colors duration-300"
            >
              <LogIn size={15} /> Continue with Google
            </button>
            <p className="mt-8 text-sm text-faint">
              Prefer email? Reach me at <span className="text-ink">{profile.email}</span>.
            </p>
          </div>
        </div>
      </main>

      <footer className="border-t border-hairline">
        <div className="container-x py-6">
          <p className="text-xs text-faint">© 2026 Ritu Mali</p>
        </div>
      </footer>
    </div>
  );
}
